var _path, _rect, _path2, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconBrandKitFolder = function SvgIconBrandKitFolder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 110,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#CFCFCF",
    d: "M31.43 99.378h97.737a6.43 6.43 0 0 0 6.43-6.43V22.86a6.43 6.43 0 0 0-6.43-6.43H70.671a6.43 6.43 0 0 1-3.566-1.08l-6.406-4.27A6.43 6.43 0 0 0 57.133 10H31.43A6.43 6.43 0 0 0 25 16.43v76.518a6.43 6.43 0 0 0 6.43 6.43"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 101.595,
    height: 51.441,
    x: 30.144,
    y: 22.93,
    fill: "#fff",
    rx: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M89.087 36.365H31.43a6.43 6.43 0 0 0-6.43 6.43v50.154a6.43 6.43 0 0 0 6.43 6.43h97.737a6.43 6.43 0 0 0 6.43-6.43V35.08a6.43 6.43 0 0 0-6.43-6.43h-25.506a6.43 6.43 0 0 0-3.858 1.285l-6.858 5.144a6.43 6.43 0 0 1-3.858 1.286"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#DADADA",
    clipPath: "url(#icon_brandKit_folder_svg__a)",
    filter: "url(#icon_brandKit_folder_svg__b)",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M107.052 62.477C99.292 62.477 93 68.86 93 76.734s6.291 14.257 14.052 14.257 14.052-6.384 14.052-14.257c0-7.874-6.29-14.257-14.052-14.257m0 21.779c-4.094 0-7.414-3.369-7.414-7.522s3.32-7.522 7.414-7.522 7.414 3.368 7.414 7.522c0 4.153-3.32 7.522-7.414 7.522M122.664 63.567c2.332 0 4.222-1.918 4.222-4.284S124.996 55 122.664 55s-4.222 1.918-4.222 4.283 1.89 4.283 4.222 4.283"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_brandKit_folder_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M93 55h34v36H93z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "icon_brandKit_folder_svg__b",
    width: 35,
    height: 37,
    x: 93,
    y: 55,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    k2: -1,
    k3: 1,
    operator: "arithmetic"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_21727_4269"
  })))));
};
export default SvgIconBrandKitFolder;